import axios from 'axios';

export function submitForm(data) {
  const url = 'dpbusiness/api/client/login';
  return axios.get(url, {params: data}).then((res) => Promise.resolve(res.data))
}



// WEBPACK FOOTER //
// ./src/api/login.js